import React, {useContext} from "react";
import FilesFolder from "./index";
import {CommunityContext} from "../../community-context";
export function FolderWrapper(props) {
const community = useContext(CommunityContext);

return <FilesFolder {...props} base={`/${community.data.handle}/explore/drive`} id={props.match.params.folderId} />;
}